module.exports = __webpack_public_path__ + "static/media/btn_vegetables.46441769.png";